import { useTypedSearchParams } from '@/hook';
import { VFlex } from '@/package';
import { VPagination } from '@/package/kiska/src/component/UI/VPagination';
import type { ModelingListSearchParams } from '@/type';

const ModelingDetailpagination = ({
  modelingCount,
}: {
  modelingCount: number;
}) => {
  const { get, set, flush } = useTypedSearchParams<ModelingListSearchParams>();
  const limit = Number(get('modelingLimit'));
  const offset = Number(get('modelingOffset'));

  const currentPage = Math.floor(offset / (limit || 1)) + 1;
  const totalPage = Math.ceil((modelingCount || 0) / (limit || 1));

  return (
    <VFlex justify="center" className="px-[10px] pt-4 pb-10">
      <VPagination
        currentPage={currentPage}
        totalPage={totalPage}
        onChange={page => {
          set('modelingOffset', `${(page - 1) * limit}`);
          flush();
        }}
      />
    </VFlex>
  );
};

export default ModelingDetailpagination;
